'use client'

import { useConfigContext } from '@/context/ConfigProvider'
import { languages } from '@/types/enum'

type ShowUnitProps = {
  unit: string | null
  unit_en?: string | null
}

export default function ShowUnit({ unit, unit_en }: ShowUnitProps) {
  const { locale } = useConfigContext()
  if (locale === languages.en) {
    return <span className="text-sm">{unit_en && unit_en !== '' ? unit_en : 'Pc'}</span>
  } else {
    return <span className="text-sm">{unit && unit !== '' ? unit : 'Cái'}</span>
  }
}
